import React, { useContext } from 'react';
import { PageContent } from 'templates/PageContent';
import { Form } from 'templates/Form';
import { TransitionButton } from 'atoms/TransitionButton';
import { Button } from '@mui/material';
import { YearMonthPicker } from 'atoms/InputField';
import { FormSectionTitle } from 'atoms/FormSectionTitle';
import { AppContext } from 'templates/AppContextProvider';
import { useSearchParams } from 'react-router-dom';

export const AgeSelectForm: React.FC<{
  children?: React.ReactNode;
  title: string;
  text?: string;
  birthDate: Date | null;
  label?: string;
  onChange?: (d: Date) => void;
  nextLabel?: string;
  onNext?: () => void;
  backLabel?: string;
  onBack?: () => void;
  savedBirthday?: string;
}> = (props) => {
  const [searchParams] = useSearchParams();
  const representative = searchParams.get('representative');
  const currentLang = useContext(AppContext).currentLang;
  const month = props.birthDate?.getMonth() ?? 0;
  const year = props.birthDate?.getFullYear() ?? 0;
  const formatDate = (month: number, year: number) => {
    const formattedMonth = String(month + 1).padStart(2, '0');
    return currentLang === 'en' ? `${formattedMonth}/${year}` : `${year}/${formattedMonth}`;
  };
  return (
    <PageContent>
      <div className="max-h-96 overflow-y-scroll">
        <Form title={props.title ?? ''}>
          <div className="mt-4">
            <FormSectionTitle text={props.label ?? ''} />
            <div className="flex mb-10 py-2">
              {props.savedBirthday && <p className="text-xl">{formatDate(month, year)}</p>}
              {!props.savedBirthday && (
                <YearMonthPicker value={props.birthDate} onChange={(d) => props.onChange?.(d)} />
              )}
            </div>
            <div className="flex justify-center items-center">
              {!representative && (
                <TransitionButton
                  label={props.backLabel}
                  onClick={props.onBack}
                  className="w-[10rem] mr-6"
                />
              )}
              <Button
                className={'w-[10rem]'}
                variant="contained"
                onClick={props.onNext}
                disabled={!props.birthDate}
                style={{
                  fontWeight: 'bold',
                  color: 'var(--c-button-text)',
                  borderRadius: '300px',
                  padding: '1rem 2rem',
                  background: props.birthDate ? 'var(--c-button-background)' : undefined,
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = 'var(--c-button-background-hover)')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = 'var(--c-button-background)')
                }
              >
                {props.nextLabel}
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </PageContent>
  );
};
